const formatRoleText = (role: string | null | undefined): string => {
  if (!role) return '-';

  return role
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export default formatRoleText;
